import React from "react";
import styled from "styled-components";
import { Mail, Phone, MapPin } from "lucide-react";

const ContactSection = styled.section`
  width: 100%;
  padding: 4rem 2rem;
  background: #f8f9fa;
  text-align: center;
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  color: #000;
  margin-bottom: 1rem;
`;

const SectionSubtitle = styled.p`
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 2rem;
`;

const ContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
`;

const ContactItem = styled.a`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.1rem;
  color: #000;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const ContactIcon = styled.span`
  display: flex;
  align-items: center;
`;

const Contact = () => {
  return (
    <ContactSection id="contact">
      <SectionTitle>Contact</SectionTitle>
      <SectionSubtitle>
        Feel free to reach out! 
      </SectionSubtitle>
      <ContactDetails>
        <ContactItem href="mailto:irenemuthoki50@gmail.com">
          <ContactIcon>
            <Mail size={20} />
          </ContactIcon>
          irenemuthoki50@gmail.com
        </ContactItem>
        <ContactItem href="tel:+254705953882">
          <ContactIcon>
            <Phone size={20} />
          </ContactIcon>
          +254 705 953 882
        </ContactItem>
        <ContactItem
          href="https://www.google.com/maps?q=Nairobi,Kenya"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ContactIcon>
            <MapPin size={20} />
          </ContactIcon>
          Nairobi, Kenya
        </ContactItem>
      </ContactDetails>
    </ContactSection>
  );
};

export default Contact;
